import react from "react";

export const reactApi = react;

//# sourceMappingURL=Interop.fs.js.map
